import { type ISbStoryData } from '@storyblok/react'

import { type StoryblokPageContentType } from '../storyblokPageContentTypes'

export const storyAccessorHasNoIndexInSeoRobots = (
  story: ISbStoryData<StoryblokPageContentType>,
): boolean => {
  const { seoRobots } = story.content

  if (!seoRobots) {
    return false
  }

  if (typeof seoRobots !== 'string') {
    return false
  }

  return seoRobots.includes('noindex')
}
